<template>
  <div>
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('listeLotPaiement.titre') }}
              </h1>
              <breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              @handleAction="handleAction"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="hasLotPaiementSelected"
            ></selecteur-action>
          </div>
          <form @submit.prevent="rechercheIntoChildren()"
                class="column is-5 pdr-0 pdl-0">
            <b-input :placeholder="$t('listeLotPaiement.recherche')" type="search" icon="magnify"
                     v-model="critereRechercheLotPaiement.auto">
            </b-input>
          </form>
          <div class='column is-narrow'>
            <button class="button" @click='setShowFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('general.button.filtre')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiserFiltre()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="level-right columns">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="constantes.LOT_PAIEMENT.exporter"
            in-progress/>
        </div>
        <parametrage-table
          :referenceTable="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <div class="mgt-20px">
      <remise-bancaire-table v-if="startArrayRendering"
        :sens="constantes.SENS_ACHAT"
        :referenceTable="referenceTable"
        :permissions="constantes.LOT_PAIEMENT"
        :moduleDcf="constantes.MODULE_BAIL"
        :ref="referenceTable">
      </remise-bancaire-table>
    </div>
    <div class="componentBrief" v-show="showFiltre === true">
      <filtre-lot-paiement ref="filtreLotPaiement"
                           @toggleFiltre="setShowFiltre"
                           @recherche="makeRechercheFilter"/>
    </div>
     <b-modal v-model="popUpGenererEcriture" has-modal-card class="modal" width="400px">
    <pop-up-prevention v-if="actionSelect === ACTION_GENERATION_ECRITURE"
      :messHeader="$t('listeLotPaiement.generationEcriture.title')"
      messFooter=""
      :cancel="$t('general.button.cancel')"
      :validate="$t('general.button.next')"
      @no="closeGenererEcriture"
      @yes="generationEcriture"
    />
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import breadcrumb from '@/components/general/breadcrumb';
import remiseBancaireTable from '@/components/remiseBancaire/listeRemiseBancaire/remiseBancaireTable';
import { SENS_ACHAT, MODULE_BAIL } from '@/configuration/devisConf';
import selecteurAction from '@/components/general/selecteurAction';
import { LOT_PAIEMENT } from '@/configuration/baux/permissionsBauxConf';
import filtreLotPaiement from '@/components/lotPaiement/filtreLotPaiement';
import subscribeMutation from '@/services/store/subscribeMutation';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_LOTS_PAIEMENTS } from '@/configuration/general/referenceTableConf';
import { ACTION_GENERATION_ECRITURE } from '@/configuration/lotPaiement/lotPaiementConf';
import messageErreur from '@/services/general/messageErreur';
import popUpPrevention from '@/components/general/popUpPrevention';
import messageSuccess from '@/services/general/messageSucces';
import {
  generateByRemiseBancaire,
} from '@/api/compta/ifEcriture';
import { TYPE_PAIEMENT } from '@/configuration/compta/ecritureConf';

const RemiseBancaire = createNamespacedHelpers('remiseBancaire');
const Societe = createNamespacedHelpers('societe');
const permissions = createNamespacedHelpers('permissions');

export default {
  components: {
    remiseBancaireTable,
    breadcrumb,
    selecteurAction,
    filtreLotPaiement,
    exportExcelButton,
    parametrageTable,
    popUpPrevention,
  },
  data() {
    return {
      actions: [{ action: ACTION_GENERATION_ECRITURE, translation: 'listeLotPaiement.actions.genererEcriture' }],
      showFiltre: false,
      unsubscribeValue: null,
      constantes: {
        SENS_ACHAT,
        LOT_PAIEMENT,
        MODULE_BAIL,
      },
      errorEdition: {
        haveError: false,
        messages: [],
        champsVide: [],
        messagesChampsVide: [],
      },
      referenceTable: REFERENCE_TABLE_LOTS_PAIEMENTS,
      startArrayRendering: false,
      ACTION_GENERATION_ECRITURE: ACTION_GENERATION_ECRITURE,
      popUpGenererEcriture: false,
      actionSelect: null,
    };
  },
  computed: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...RemiseBancaire.mapGetters({
      lotsPaiement: 'items',
      critereRechercheLotPaiement: 'critereRechercheLotPaiement',
    }),
    ...Societe.mapGetters({
      lockMenu: 'lockMenu',
    }),
    breadcrumb() {
      return [
        { title: this.$t('listeLotPaiement.breadcrumb.accueil'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('listeLotPaiement.breadcrumb.listeLotPaiement'), route: '', isActive: true },
      ];
    },
    hasLotPaiementSelected() {
      return this.lotsPaiement.filter((remiseBancaire) => {
        return remiseBancaire.selected === true;
      }).length > 0;
    },
    nombreCritere() {
      let nbCritere = calculNombreCritere(this.critereRechercheLotPaiement, ['auto', 'exporteeEnCompta', 'sens', 'datesRemise']);
      if (this.critereRechercheLotPaiement.exporteeEnCompta !== null) nbCritere += 1;
      if (this.critereRechercheLotPaiement.datesRemise.dateDebut !== null) nbCritere += 1;
      if (this.critereRechercheLotPaiement.datesRemise.dateFin !== null) nbCritere += 1;
      return nbCritere > 9 ? '+9' : nbCritere;
    },
  },
  methods: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    getAllLotPaiementSelected() {
      return this.lotsPaiement.filter((el) => {
        return el.selected;
      });
    },
    closeGenererEcriture() {
      this.popUpGenererEcriture = false;
    },
    async generationEcriture() {
      try {
        this.debutLoading();
        this.popUpGenererEcriture = false;
        const promises = [];
        const ids = this.getAllLotPaiementSelected().map((lotPaiement => lotPaiement.id));

        ids.forEach(id => {
          promises.push(generateByRemiseBancaire({
            referencePieceId: id,
            typeEcriture: TYPE_PAIEMENT,
          }));
        });
        await Promise.all(promises);
        this.finLoading();
        this.selectAll();
        messageSuccess(this.$i18n.t('listeLotPaiement.generationEcriture.success'));
      } catch (e) {
        this.finLoading();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    selectAll() {
      const select = !this.getAllLotPaiementSelected;
      this.lotsPaiement.forEach((el) => {
        el.selected = select;
      });
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreLotPaiement.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    async reinitialiserFiltre() {
      await this.$refs.filtreLotPaiement.initializeFiltre();
      this.$refs.filtreLotPaiement.viderCritere();
      this.$refs.filtreLotPaiement.appliquerCritere();
      this.showFiltre = false;
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.rechercheIntoChildren();
    },
    handleAction(action) {
      this.actionSelect = action;
      switch (action) {
        case ACTION_GENERATION_ECRITURE:
          if (this.checkPermissions(this.constantes.LOT_PAIEMENT.maj)) {
            this.errorEdition.messages = [];
            this.errorEdition.haveError = false;
            this.popUpGenererEcriture = true;
          } else this.showPopUp();
          break;
        default:
          messageErreur(this.$i18n, this.$i18n.t('listeLotPaiement.error.noActionSelect'));
          break;
      }
    },
    rechercheIntoChildren() {
      this.$refs[this.referenceTable].recherche();
    },
    goFirstPageIntoChildren() {
      this.$refs[this.referenceTable].goFirstPage();
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
    if (this.lockMenu) this.setLockMenu(false);
  },
  created() {
    if (this.$route.params.idsLots) {
      this.critereRechercheLotPaiement.id = [...new Set(JSON.parse(this.$route.params.idsLots))];
    }
  },
  async mounted() {
    this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.rechercheIntoChildren, this.goFirstPageIntoChildren);
    this.setInformationPage(this.$t('pageBaux.lotPaiement.liste'));
  },
};
</script>
